import { Autocomplete, Grid, TextField } from '@mui/material'
import React from 'react'

const Confirmation = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <Autocomplete
      value={moduleValues?.['Placement Confirmation'] ?? []}
      options={[
        'Auscultation',
        'Capnography (ETCO2)',
        'Visual Inspection',
        'Chest Rise',
        'Fogging in Tube',
        'Pulse Oximetry',
        'Esophageal Detection Device (EDD)',
        'X-ray Confirmation',
        'Colorimetric CO2 Detector',
        'Direct Visualization (Laryngoscopy)',
        'Patient Improvement',
      ]}
      multiple
      freeSolo
      onChange={(e, value) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Placement Confirmation']: value,
        }))
      }
      renderInput={(params) => (
        <TextField {...params} label="Placement Confirmation" />
      )}
    />
  </Grid>
)

export default Confirmation
